/**
 * @file コンポーネント：フル動画ページフル動画プレイヤーアイコンリスト DOM管理
 */

// ライブラリ読み込み
import React from "react";

// コンポーネント読み込み

// スタイル読み込み
import {
    StyledContent,
    StyledContentBalloon,
    StyledContentBalloonContainer,
    StyledContentBalloonText,
    StyledContentBalloonTime,
    StyledContentIcon,
    StyledContentList,
    StyledContentListItem,
} from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ReactDOM
    return (
        <StyledContent ref={props.refFullvideoPlayerIconlist}>
            {props.isShowIconComment === true && (
                // コメント
                <StyledContentList>
                    {props.listComment !== null &&
                        props.listComment.map((item, index) => (
                            <StyledContentListItem
                                key={"comment-" + index}
                                style={{ left: item.position + "%" }}
                                onMouseEnter={(e) =>
                                    props.fnOnMouseEnterIcon(e)
                                }
                            >
                                <StyledContentIcon
                                    onClick={() => props.fnJump(item.time)}
                                >
                                    <i className="fas fa-comment"></i>
                                </StyledContentIcon>
                                <StyledContentBalloon>
                                    <StyledContentBalloonContainer
                                        onClick={() => props.fnJump(item.time)}
                                    >
                                        <StyledContentBalloonText>
                                            {item.text}
                                        </StyledContentBalloonText>
                                        <StyledContentBalloonTime>
                                            {item.time}
                                        </StyledContentBalloonTime>
                                    </StyledContentBalloonContainer>
                                </StyledContentBalloon>
                            </StyledContentListItem>
                        ))}
                </StyledContentList>
            )}
            {props.isShowIconTopic === true && (
                // トピック
                <StyledContentList>
                    {props.listTopic !== null &&
                        props.listTopic.map((item, index) => (
                            <StyledContentListItem
                                key={"topic-" + index}
                                style={{ left: item.position + "%" }}
                                onMouseEnter={(e) =>
                                    props.fnOnMouseEnterIcon(e)
                                }
                            >
                                <StyledContentIcon
                                    onClick={() => props.fnJump(item.time)}
                                >
                                    <i className="fas fa-comments"></i>
                                </StyledContentIcon>
                                <StyledContentBalloon>
                                    <StyledContentBalloonContainer
                                        onClick={() => props.fnJump(item.time)}
                                    >
                                        <StyledContentBalloonText>
                                            {item.text}
                                        </StyledContentBalloonText>
                                        <StyledContentBalloonTime>
                                            {item.time}
                                        </StyledContentBalloonTime>
                                    </StyledContentBalloonContainer>
                                </StyledContentBalloon>
                            </StyledContentListItem>
                        ))}
                </StyledContentList>
            )}
            {props.isShowIconEvent === true && (
                // イベント
                <StyledContentList>
                    {props.listEvent !== null &&
                        props.listEvent.map((item, index) => (
                            <StyledContentListItem
                                key={"event-" + index}
                                style={{ left: item.position + "%" }}
                                onMouseEnter={(e) =>
                                    props.fnOnMouseEnterIcon(e)
                                }
                            >
                                <StyledContentIcon
                                    onClick={() => props.fnJump(item.time)}
                                >
                                    <i className="fas fa-flag"></i>
                                </StyledContentIcon>
                                <StyledContentBalloon>
                                    <StyledContentBalloonContainer
                                        onClick={() => props.fnJump(item.time)}
                                    >
                                        <StyledContentBalloonText>
                                            {item.text}
                                        </StyledContentBalloonText>
                                        <StyledContentBalloonTime>
                                            {item.time}
                                        </StyledContentBalloonTime>
                                    </StyledContentBalloonContainer>
                                </StyledContentBalloon>
                            </StyledContentListItem>
                        ))}
                </StyledContentList>
            )}
        </StyledContent>
    );
};
